import React from 'react';
import useServicesPerMonthPerYearPercentageChart from './hooks/useServicesPerMonthPerYearPercentageChart';
import ChartContainer from '../../../Common/Services/charts/apex-charts/ChartContainer';
import { useServicesChartsDataContext } from './hooks/useServicesChartsDataContext';

export const ServicesPerMonthPerYearPercentage = ({ height = 400 }) => {
    const { module } = useServicesChartsDataContext();
    const { chartConfig } = useServicesPerMonthPerYearPercentageChart();

    return (
        <ChartContainer
            title={`Evolução ${module.sectionTitle} Mensal no Ano Selecionado (%)`}
            options={chartConfig.options}
            series={chartConfig.series}
            height={height}
        />
    );
};
